<template>
	<StandardCard>
		<button type="button" class="flex w-full gap-4 min-h-14 text-left px-6 py-4" @click="toggle">
			<MailIcon v-if="icon === 'mail'" class="text-qwr-dark mt-1 size-4 flex-none" />
			<GiftIcon v-if="icon === 'gift'" class="text-qwr-dark mt-1 size-4 flex-none" />

			<span class="flex-1 block">{{ title }}</span>

			<ChevronIcon class="mt-1 h-3 flex-none transition-transform" :class="{'rotate-90': !isOpen, '-rotate-90': isOpen}" />
		</button>
		<div
			:class="{
      'overflow-hidden transition-accordion': true,
      'max-h-0 opacity-0 duration-200': !isOpen,
      'max-h-800 opacity-100 duration-500': isOpen
    }"
		>
			<div class="px-6 pb-6">
				<slot />
			</div>
		</div>
	</StandardCard>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import StandardCard from '@/components/StandardCard.vue';
import ChevronIcon from '@/theme/icons/chevron.svg?component';
import MailIcon from '@thermenresorts/icons/svg/mail.svg';
import GiftIcon from '@thermenresorts/icons/svg/gift.svg';

export interface Props {
  title: string
  opened?: boolean
  icon?: 'mail' | 'gift' | null
}

const props = withDefaults(defineProps<Props>(), {
  opened: false,
  icon: null,
});

const emit = defineEmits([
  'open',
  'close',
]);

const isOpen = ref(props.opened);

const toggle = () => {
  isOpen.value = !isOpen.value;
  emit(isOpen.value ? 'open' : 'close');
};
</script>
